import { RectSize } from "../../../utils/RectSize";
import { AppSettings } from "../../managers/AppSettings";

export class SideScoreItem
    extends Phaser.GameObjects.Container
{
    public grBg: Phaser.GameObjects.Graphics;
    public txtTitle: Phaser.GameObjects.Text;
    public grValueBg: Phaser.GameObjects.Graphics;
    public txtValue: Phaser.GameObjects.Text;

    private size: RectSize = new RectSize(400, 150);


    public Init(): void
    {

    }

    /**
     * NOTE: content is self-centered
     */
    public Build(): void
    {
        this.grBg = this.scene.make.graphics({});
        this.grBg.clear();
        this.grBg.fillStyle(0x001701, 1);
        this.grBg.fillRoundedRect(-this.size.width/2, -this.size.height/2, this.size.width, this.size.height, 20);
        this.add(this.grBg);

        this.txtTitle = this.scene.make.text({
            x: 0, 
            y: -0.35 * this.size.height, 
            style: {
                color: "#fff", 
                fontSize: "25px", 
                align: "center", 
                fontFamily: AppSettings.fontFamilies.MontserratBold,
                metrics: AppSettings.metrics.montserratBold25,
            }
        });
        this.txtTitle.setOrigin(0.5);
        this.add(this.txtTitle);

        // NOTE: redraw inside SetData with appropriate color
        this.grValueBg = this.scene.make.graphics({});
        this.add(this.grValueBg);

        this.txtValue = this.scene.make.text({
            x: 0, 
            y: 0.1 * this.size.height, 
            style: {
                color: "#fff", 
                fontSize: "45px", 
                align: "center", 
                fontFamily: AppSettings.fontFamilies.MontserratBold,
                metrics: AppSettings.metrics.montserratBold45,
            }
        });
        this.txtValue.setOrigin(0.5);
        this.add(this.txtValue);
    }

    /**
     * Set localized title
     * @param value 
     */
    public SetTitle(value: string): void
    {
        this.txtTitle.text = value;
    }

    /**
     * Set value
     * @param value 
     */
    public SetData(value: number, valueBgColor: number): void
    {
        this.txtValue.text = value.toString();

        // redraw valueBg with appropriate color
        this.grValueBg.clear();
        this.grValueBg.fillStyle(valueBgColor, 1);
        this.grValueBg.fillRoundedRect(
            -this.size.width * 0.4, 
            -this.size.height * 0.2, 
            this.size.width * 0.8, 
            this.size.height * 0.6,
            20
        );
    }
}